import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Container, Image, HeaderTitle, SubContainerButton, SubContainerField, ContainerImage, ContainerFieldLocation, ContainerContent, ViewVazia } from './style'
import Input from '../../components/Input/Input'
import Button from '../../components/Button/Button'
import logo from '../../assets/images/logo.png'
import disableBrowserBackButton from 'disable-browser-back-navigation'
import ModalAlert from '../../components/ModalAlert/ModalAlert'
import { registerPointReset, registerPointSave }  from '../../services/store/reducers/registerPoint'
import CurrentTime from '../../components/CurrentTime/CurrentTime'
import { checkGeolocation } from '../../helpers/geo'
import { fetchRegistrarInfoStart } from '../../services/store/reducers/endpoints/registrarinfo'
//sagas
import { fetchFindDataByReStart, findDataByReReset }  from '../../services/store/reducers/endpoints/findDataByRE'
class RegisterPoint extends PureComponent{
  state = {
    re: '',
    disabledReField: false,
    acaoButton: 'Buscar',
    tentativasErradas: 0,    
    sendedBusca: false,
    sendedConfirmation: false,
    confirmModal: false
  }

  UNSAFE_componentWillMount () {
    disableBrowserBackButton()
    console.log('reducers', this.props.pointFlow)
    this.props.registerPointReset()
  }

  // componentDidMount(){
  //   this.setState({confirmModal: true,  titleModal: 'Atenção!', messageModal: 'Seus dados estão corretos?'})
  //   // this.setState({confirmModal: true,  titleModal: 'Atenção!', messageModal: 'Seus dados estão corretos? Seus dados estão corretos? Seus dados estão corretos? Seus dados estão corretos? Seus dados estão corretos? Seus dados estão corretos? Seus dados estão corretos?'})
    
  // }

  /* 
  Ação de continuar  
  */
  continuar = () => {
    //this.setState({ })
    this.setState({confirmModal: true,  titleModal: 'Atenção!', messageModal: 'Seus dados estão corretos?'})
   /* <br> Nome: ' + sagaFindDataByRe.usuario.nome +'  <br> Cliente:  '+  sagaFindDataByRe.usuario.nomeCliente +'  <br> Unidade: ' + sagaFindDataByRe.usuario.nomeUnidade*/
    
  }

  continuarSim = () => {
    console.log('1continuarSim-->')
    this.setState({ confirmModal: false})
    //internet
    if (!window.navigator.onLine) {
      this.setState({titleModal: 'Sem Internet!', messageModal: 'Você precisa estar conectado a uma rede para prosseguir'})
      return
    }
    console.log('2continuarSim-->')

    /*if(this.props.appConfig.geoLocalizacao && !this.props.sagaFindDataByRe.usuario.coordenadas){
      this.setState({titleModal: 'Atenção!', messageModal: 'As coordenadas referentes a essa unidade (' + this.props.sagaFindDataByRe.usuario.nomeUnidade + ') não foram configuradas! Por favor entre em contato com o supervisor!'})
      return
    }*/
    console.log('3continuarSim-->')

    this.props.registerPointSave({
      re: this.state.re,
      
      codCliente: this.props.sagaFindDataByRe.usuario.codCliente,
      codUnidade: this.props.sagaFindDataByRe.usuario.codUnidade,
      name: this.props.sagaFindDataByRe.usuario.nome,
      nomeCliente: this.props.sagaFindDataByRe.usuario.nomeCliente,
      nomeUnidade: this.props.sagaFindDataByRe.usuario.nomeUnidade,

      coordenadas: this.props.sagaFindDataByRe.usuario.coordenadas,
      horarioEntrada: this.props.sagaFindDataByRe.usuario.horarioEntrada,
      horarioSaida: this.props.sagaFindDataByRe.usuario.horarioSaida,
      horarioIntervalo: this.props.sagaFindDataByRe.usuario.horarioIntervalo,
      trocarSenha:  this.props.sagaFindDataByRe.usuario.trocarSenha,
      tipo:  this.props.sagaFindDataByRe.usuario.tipo,

      toleranciaAntecipacao: this.props.sagaFindDataByRe.toleranciaAntecipacao,
      toleranciaAtraso: this.props.sagaFindDataByRe.toleranciaAtraso,
      endereco: this.props.sagaFindDataByRe.usuario.endereco,
      codigoAssociacao: this.props.sagaFindDataByRe.usuario.codigoAssociacao,
    })
    console.log('4continuarSim-->')

    console.log('resultados: ', this.props.registerPoint)
    
    checkGeolocation().then((result) => {
      console.log('5continuarSim-->')
      if(result){ 
        console.log('6continuarSim-->')
        //window.location.href = '/confirmation-point'
        window.location.href = '/point-flow'
      }else{
        this.props.fetchRegistrarInfoStart({          
          "RE": this.state.re,
          "Empresa": this.props.home.company,
          "Cliente": this.props.sagaFindDataByRe.usuario.codCliente,
          "Unidade": this.props.sagaFindDataByRe.usuario.codUnidade,
          "Detalhes": "Usuário não está com GPS habilitado."
        })
        window.location.href='/report-user?message=Você não esta com gps&errorCode=2'
      }
    })

    

  }

  continuarNao = () => {
    this.setState({ re: '', confirmModal: false})
    this.props.findDataByReReset()
    this.setState({disabledReField: false, acaoButton: 'Buscar'})
  }

  voltar = () => {
    if (!window.navigator.onLine) {
      this.setState({titleModal: 'Sem Internet!', messageModal: 'Você precisa estar conectado a uma rede para prosseguir'})
      return
    }
    window.location.href = '/home'
  }
 
  reOnChange = (value) => {
    this.setState({re: value})
  }

  onBlurRe = () => {
    //deixa vazio por enquanto
  }

  /* 
  Ação de buscar  
  */
  buscar = () => {
    if (!window.navigator.onLine) {
      this.setState({titleModal: 'Atenção!', messageModal: 'Você precisa estar conectado a uma rede para prosseguir'})
      return
    }
    this.props.findDataByReReset()
    this.props.fetchFindDataByReStart({re: this.state.re, company: this.props.home.company})
    this.setState({acaoButton: 'Aguarde...', sendedBusca: true, disabledReField: true})
  }

  alterarButtonParaContinuar = () => {
    this.setState({acaoButton: 'Continuar', sendedBusca: false})
  }

  notFound = () => {
    //para definir a msg
    this.setState({titleModal: 'Atenção!', messageModal: 'Colaborador não encontrado.'})
    this.setState({
      re: '',
      acaoButton: 'Buscar', 
      tentativasErradas: this.state.tentativasErradas + 1, 
      disabledReField: false,
      sendedBusca: false
    }) 
  }
  handleKeyPress = (event) => {
    var key = event.charCode ? event.charCode : event.keyCode
    
    if(
      ["-", "+", ".", "e", ",", "-"].includes(event.key)
      || key === 46
    ) {
      event.preventDefault()
      return false
    }
    
    if(event.key === 'Enter'){
      this.buscar()
    }
  }


 

  render() {
    
    const { sagaFindDataByRe } = this.props 

    console.log('reducer > registerPoint: ', this.props.registerPoint)
    return (
      <Container>
        <ContainerImage>
          <Image src={logo} />
        </ContainerImage>

        <CurrentTime></CurrentTime>
        
        <ContainerContent>
          <HeaderTitle>Preencha sua Matrícula</HeaderTitle>
          
        </ContainerContent>
        
        <ContainerContent>
          
          <ContainerFieldLocation>
            <SubContainerField>
              <Input 
                
                type='number'
                name='oldPassword' placeholder='RE/Matrícula' 
                disabled={this.state.disabledReField}
                onKeyDown={(event) => { this.handleKeyPress(event)}}
                onChange={(event) => {
                   this.reOnChange(event.target.value.substr(0,6))
                  }} 
                  value={this.state.re}
                onBlur={ () => { this.onBlurRe() } }
              autoComplete='off' />
            </SubContainerField>
          </ContainerFieldLocation>

          <ContainerFieldLocation>
            <SubContainerField>
              <Input 
                opacity={0.7}
                disabled={true} 
                value={ sagaFindDataByRe && !Array.isArray(sagaFindDataByRe) ? sagaFindDataByRe.usuario.nome : '' }
                type='text' name='oldPassword' placeholder='Nome do Colaborador' 
              autoComplete='off' />
            </SubContainerField>
          </ContainerFieldLocation>

          <ContainerFieldLocation>
          <SubContainerField>
            <Input 
              opacity={0.7}
              disabled={true} 
              value={ sagaFindDataByRe && !Array.isArray(sagaFindDataByRe) ? sagaFindDataByRe.usuario.nomeCliente : '' }
              type='text' name='oldPassword' placeholder='Cliente' autoComplete='off' 
            />
          </SubContainerField>
          </ContainerFieldLocation>

        <ContainerFieldLocation>
        <SubContainerField>
          <Input 
            opacity={0.7}
            disabled={true} 
            value={ sagaFindDataByRe && !Array.isArray(sagaFindDataByRe) ? sagaFindDataByRe.usuario.nomeUnidade : '' }
            type='text' name='oldPassword' placeholder='Unidade' 
          autoComplete='off' />
        </SubContainerField>
        </ContainerFieldLocation>
        </ContainerContent>

        <SubContainerButton>
          {
            this.state.tentativasErradas >= 2 ?
            <Button width='130px' backgroundColor='#40bbca' onClick={() => { this.voltar() }}>Voltar</Button>
            :
            <ViewVazia style={{width: '130'}}></ViewVazia>
          }          
          <Button width='130px' 
            onClick={() => { 
              if(this.state.acaoButton === 'Buscar') {
                this.buscar()
              }
              if(this.state.acaoButton === 'Continuar'){
                this.continuar()
              }
             }}
          >{this.state.acaoButton}</Button>
        </SubContainerButton>

        {
          sagaFindDataByRe &&
          !Array.isArray(sagaFindDataByRe) &&
          this.state.sendedBusca &&
          this.alterarButtonParaContinuar()
        }
        {
          sagaFindDataByRe &&
          Array.isArray(sagaFindDataByRe) &&
          sagaFindDataByRe.length === 0 &&
          this.state.sendedBusca &&
          this.notFound()
        }
        {
          //para colocar os pop up
          this.state.titleModal && 
          this.state.messageModal &&
          this.state.titleModal.length > 0 &&
          this.state.messageModal.length > 0 &&
          <ModalAlert 
            noBackgroundBlack={this.state.confirmModal}
            modalUp={this.state.confirmModal}
            title={this.state.titleModal } 
            message={ this.state.messageModal }  
            confirmModal={this.state.confirmModal}
            confirmSim={ () => { this.continuarSim() }}
            confirmNao={ () => { this.continuarNao() }}
            onClick={() => { this.setState({messageModal: '', titleModal: ''}) } }
            />
        }
        
     </Container>
    )
  }
}

const mapStateToProps = state => ({
  home: state.home,
  sagaFindDataByRe: state.sagaFindDataByRe.data,
  pointFlow: state.pointFlow,
  registerPoint: state.registerPoint,
  appConfig: state.appConfig
  
})

const mapDispatchToProps = dispatch => ({
  registerPointReset: () => dispatch(registerPointReset()),
  registerPointSave: (value) => dispatch(registerPointSave(value)),
  fetchFindDataByReStart: (mss) => dispatch(fetchFindDataByReStart(mss)),
  findDataByReReset: () => dispatch(findDataByReReset()),
  fetchRegistrarInfoStart: (value) => dispatch(fetchRegistrarInfoStart(value))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterPoint)
